<template>
  <WLSlider v-bind="$props" class="relative">
    <template #start="{ index, arrivedState, setIndex }">
      <Transition name="fade">
        <WLButton
          v-show="!arrivedState.left"
          :size="ButtonSize.EXTRA_SMALL"
          :variant="ButtonVariant.ELEVATED"
          :type="ButtonType.SECONDARY"
          class="absolute left-4 top-1/2 z-20 hidden -translate-y-1/2 md:flex"
          :icon="IconName.NAVIGATION_CHEVRON_LEFT"
          @click="setIndex(index - 1)"
        />
      </Transition>
      <Transition name="fade">
        <WLButton
          v-show="!arrivedState.right"
          :size="ButtonSize.EXTRA_SMALL"
          :variant="ButtonVariant.ELEVATED"
          :type="ButtonType.SECONDARY"
          class="absolute right-4 top-1/2 z-20 hidden -translate-y-1/2 md:flex"
          :icon="IconName.NAVIGATION_CHEVRON_RIGHT"
          @click="setIndex(index + 1)"
        />
      </Transition>
    </template>
    <template #default="props">
      <slot v-bind="props" />
    </template>
  </WLSlider>
</template>

<script setup lang="ts">
import { ButtonSize, ButtonType, ButtonVariant, WLButton } from "../button";
import { IconName } from "../icon";
import { WLSlider, type SliderProps } from "../slider";

defineProps<SliderProps>();
</script>
